import { mapKeys, fromPairs, toPairs, sortBy } from "../../utils/lodash";
import { ElementWithProperties } from "../ElementWithProperties";
import { ElementWithSettings } from "../ElementWithSettings";
import { Skippable } from "../Skippable";
import { createLogic } from "./logicFactory";
import { Translatable } from "../Translatable";

export function createElementWithProperties(el?: any): ElementWithProperties {
    if (el == null) return;
    const pairs = toPairs(el.properties);
    const props = sortBy(pairs, 0);
    return {
        name: el.name,
        properties: fromPairs(props),
    };
}

export function createElementWithSettings(el?: any): ElementWithSettings {
    if (el == null) return;
    const pairs = toPairs(el.settings);
    const sets = sortBy(pairs, 0);
    return {
        name: el.name,
        settings: fromPairs(sets),
    };
}

export function createSkippable(el?: any, displayLogic?: any): Skippable {
    if (el == null) return;
    return {
        skipLogic: createLogic(el.skipLogic),
        displayLogic: createLogic(displayLogic ?? el.displayLogic),
    };
}

export function createTranslatable(el?: any): Translatable {
    if (el == null) return;
    return {
        translatedTexts: mapKeys(el.translatedTexts, (_v, k: string) => k.toLowerCase()),
    };
}
